<template>
  <div>
    <section>
      <header>
        <el-breadcrumb>
          <!-- 组织架构-->
          <el-breadcrumb-item>{{
            $t("message.organizationalStructure")
          }}</el-breadcrumb-item>
          <!--  用户列表-->
          <el-breadcrumb-item>{{ $t("message.usersList") }}</el-breadcrumb-item>
          <!-- 编辑角色、可进入系统信息-->
          <el-breadcrumb-item>{{
            JSON.stringify($route.query) === "{}"
              ? $t("message.addMembers")
              : $t("message.editMemberInformation")
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </header>
      <div class="content">
        <footer>
          <div class="footerText">
            {{
              JSON.stringify($route.query) === "{}"
                ? $t("message.addMembers")
                : $t("message.editMemberInformation")
            }}
          </div>
          <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="demo-ruleForm" label-width="120px">
            <!--账户类型：-->
            <el-form-item :label="$t('message.accountType')" prop="is_transient">
              <el-select v-model="ruleForm.is_transient" style="width: 488px"
                v-if="JSON.stringify($route.query) === '{}'">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-input v-model="is_transient" v-else disabled style="width: 488px"></el-input>
              <!--请输入系统账号-->
            </el-form-item>
            <!-- 账号头像：-->
            <el-form-item :label="$t('message.systemHeadImage')" prop="pic">
              <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
                :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :data="{
                  save_path: 'tim/',
                  new_name: $route.query.id ? 'A_s_' + $route.query.id : 'A_s_rand',
                }">
                <img v-if="ruleForm.pic" :src="ruleForm.pic" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <!--系统账号：-->
            <el-form-item :label="$t('message.newSystemAccount')" prop="username">
              <el-input v-model="ruleForm.username" style="width: 488px"
                :placeholder="$t('message.pleaseEnterTheSystemAccount')"
                :disabled="japanUserRoleInfo.username != 'Y001' && japanUserRoleInfo.username != 'M001'"></el-input>
              <!--请输入系统账号-->
            </el-form-item>
            <!--密码-->
            <el-form-item :label="$t('message.password')" :prop="!$route.query.id ? 'password' : ''">
              <el-input type="password" v-model="ruleForm.password" style="width: 488px"
                :placeholder="$t('message.enterYourPIN')"></el-input>
              <!--请输入密码-->
            </el-form-item>
            <!--真实姓名-->
            <el-form-item :label="$t('message.newRealname')" prop="realname">
              <el-input v-model="ruleForm.realname" style="width: 488px"
                :placeholder="$t('message.pleaseEnterYourRealname')"></el-input>
              <!--请输入真实姓名-->
            </el-form-item>
            <!--性别-->
            <el-form-item :label="$t('message.newSex')" prop="sex">
              <el-radio v-model="ruleForm.sex" :label="1">{{
                $t("message.man")
                }}</el-radio><!--男-->
              <el-radio v-model="ruleForm.sex" :label="0">{{
                $t("message.girl")
                }}</el-radio><!--女-->
            </el-form-item>
            <!-- 电话号码-->
            <el-form-item :label="$t('message.telephoneNumber')" prop="mobile"><!--商品数量-->
              <el-input v-model="ruleForm.mobile" style="width: 488px" />
            </el-form-item>
            <!-- 聊天显示名称-->
            <el-form-item :label="$t('message.chatDisplayName')" prop="im_nick"><!--商品单价-->
              <el-input v-model="ruleForm.im_nick" style="width: 488px" />
            </el-form-item>
          </el-form>
          <div class="flexAndCenter" style="margin-top: 48px">
            <!--        保存-->
            <el-button @click="submitAddAccountNumber" type="primary" style="margin: 0 16px 0 40px">{{
              $t("message.save")
              }}</el-button>
            <!--        返回-->
            <el-button @click="$router.go(-1)">{{
              $t("message.return")
              }}</el-button>
          </div>
        </footer>
        <!-- 选择角色 -->

        <div class="selectRole">
          <div class="row">
            <div class="label">{{ $t('message.selectRole') }}：</div>
            <div class="val"> <el-select v-model="ruleForm.roleSet" multiple filterable
                :placeholder="$t('message.selectRole')" @visible-change="usableDefaultUsername">
                <el-option v-for=" item in roleList " :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select></div>
          </div>
          <div class="row">
            <div class="label">{{ $t('message.canEnterTheSystem') }}：</div>
            <div class="val"> <el-select v-model="ruleForm.systemSet" multiple
                :placeholder="$t('message.pleaseSelectSubsystem')">
                <el-option v-for=" item in systemList " :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {
      japanUserRoleInfo: JSON.parse(localStorage.getItem('japanUserRoleInfo')),
      options: [
        {
          value: 1,
          label: "临时",
        },
        {
          value: 0,
          label: "正式",
        },
      ],
      is_transient: "",
      ruleForm: {
        username: "",
        realname: "",
        password: "",
        sex: 1,
        mobile: "",
        im_nick: "",
        is_transient: 0,
        pic: '',
        roleSet: [],
        systemSet: [],
      },
      roleList: [],

      systemList: [],
    };
  },
  computed: {
    rules() {
      return {
        username: {
          required: true,
          message: this.$t("message.pleaseEnterTheSystemAccount"),
          trigger: "blur",
        }, //请输入系统账号
        realname: {
          required: true,
          message: this.$t("message.newPleaseEnterYourRealname"),
          trigger: "blur",
        }, //请输入真实姓名
        password: {
          required: true,
          message: this.$t("message.enterYourPIN"),
          trigger: "blur",
        }, //请输入密码
        mobile: {
          required: true,
          message: this.$t("message.pleaseEnterThePhoneNumber"),
          trigger: "blur",
        }, //请输入电话号码
        im_nick: {
          required: true,
          message: this.$t("message.pleaseEnterAChatName"),
          trigger: "blur",
        }, //请输入聊天名称
        pic: {
          required: true,
          message: this.$t("message.pleaseEnterTheSystemHeadImage"),

        }, //请选择头像
      };
    },
  },
  created() {
    if (JSON.stringify(this.$route.query) !== "{}") {
      this.getAccountNumberList();
    }
    this.$api.roleApi.roleList({ pageSize: 999999999999999, page: 1, searchText: '' }).then((res) => {
      this.roleList = res.data.data;
    });
    this.$api.roleApi.subsystemList().then((res) => {
      this.systemList = res.data;
    });
  },
  methods: {
    //提交添加的账号
    submitAddAccountNumber() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (JSON.stringify(this.$route.query) === "{}") {
            if (this.ruleForm.roleSet == false) {
              //是否添加该账号                           提示
              this.$confirm(
                '角色为空，但是保存不限制,是否添加该账号',
                this.$t("message.hint"),
                {
                  confirmButtonText: this.$t("message.confirm"), //确定
                  cancelButtonText: this.$t("message.cancel"), //取消
                  type: "warning",
                  center: true,
                }
              )
                .then(() => {
                  this.$api.roleApi
                    .addAccountNumber(this.ruleForm)
                    .then((res) => {
                      this.$message.success(res.msg);
                      setTimeout(() => {
                        this.$router.go(-1);
                      }, 1000);
                    });
                })
                .catch((err) => {
                  this.$message({
                    type: "info",
                    message: this.$t("message.theAdditionHasBeenCanceled"), //已取消添加
                  });
                });
            } else {
              //是否添加该账号                           提示
              this.$confirm(
                this.$t("message.whetherToAddTheAccount"),
                this.$t("message.hint"),
                {
                  confirmButtonText: this.$t("message.confirm"), //确定
                  cancelButtonText: this.$t("message.cancel"), //取消
                  type: "warning",
                  center: true,
                }
              )
                .then(() => {
                  this.$api.roleApi
                    .addAccountNumber(this.ruleForm)
                    .then((res) => {
                      this.$message.success(res.msg);
                      setTimeout(() => {
                        this.$router.go(-1);
                      }, 1000);
                    });
                })
                .catch((err) => {
                  this.$message({
                    type: "info",
                    message: this.$t("message.theAdditionHasBeenCanceled"), //已取消添加
                  });
                });
            }

          } else {
            //是否修改该账号的信息                           提示
            this.$confirm(
              this.$t("message.whetherToModifyTheAccountInformation"),
              this.$t("message.hint"),
              {
                confirmButtonText: this.$t("message.confirm"), //确定
                cancelButtonText: this.$t("message.cancel"), //取消
                type: "warning",
                center: true,
              }
            )
              .then(() => {
                this.ruleForm.id = this.$route.query.id;
                this.$api.roleApi
                  .updateAccountNumber(this.ruleForm)
                  .then((res) => {
                    this.$message.success(res.msg);
                    setTimeout(() => {
                      this.$router.go(-1);
                    }, 1000);
                  });
              })
              .catch((err) => {
                this.$message({
                  type: "info",
                  message: this.$t("message.modificationCancelled"), //已取消修改
                });
              });
          }
        }
      });
    },
    getAccountNumberList() {
      this.$api.roleApi
        .accountNumberList({
          id: this.$route.query.id,
        })
        .then((res) => {
          this.is_transient =
            res.data.data[0].is_transient === 0 ? "正式" : "临时";
          this.ruleForm = {
            username: res.data.data[0].username,
            realname: res.data.data[0].realname,
            password: res.data.data[0].pwd,
            sex: res.data.data[0].sex,
            mobile: res.data.data[0].mobile,
            im_nick: res.data.data[0].im_nick,
            is_transient: res.data.data[0].is_transient,
            pic: res.data.data[0].pic,
            roleSet: [],
            systemSet: []
          };
          res.data.data[0].role.forEach(item => {
            this.ruleForm.roleSet.push(item.id)
          })
          res.data.data[0].admin_system.forEach(item => {
            this.ruleForm.systemSet.push(item.system_id)
          })
        });
    },
    //账号-获取默认账号名
    usableDefaultUsername(e) {

      if (!e) {
        let itemData = this.roleList.find(item => item.id == this.ruleForm.roleSet[0])
        if (itemData) {
          if (!this.$route.query.id) {
            this.$api.roleApi.usableDefaultUsername({ work_type: itemData.work_type.work_type }).then(res => {
              this.ruleForm.username = res.data
            })
          }

        }
      }
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
      }
      return isJPG || isPNG || isSVG;
    },
    //上传成功
    handleAvatarSuccess(res) {
      this.ruleForm.pic = res.data
      this.$forceUpdate()

    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;

  .accountCategory {
    flex: 1;
    margin-left: 20px;
  }
}

.flexAndCenter {
  display: flex;
  align-items: center;
}

section {
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  header {
    border-radius: 8px;
    background: #f8f8f8;
    padding: 24px;
    margin-bottom: 24px;
  }

  footer {
    border-radius: 8px;
    background: #f8f8f8;
    padding: 0 24px;

    .footerText {
      color: #999999;
      margin-bottom: 30px;
    }
  }
}

/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.selectRole {
  flex: 1;

  .row {
    display: flex;
    margin-bottom: 10px;

    .label {
      line-height: 40px;
      width: 120px;
      margin-right: 10px;
    }

    .val {
      flex: 1;

      .el-select {
        width: 100%;
      }
    }
  }
}
</style>